import PicklistMetadata from "../PicklistMetadata";

class UserEmailPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "UserEmail";
        this.bounded = true;
        this.enterpriseComponent = "UserEmail";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.sortSpecification = null;
        this.static = false;
        this.typeField = null;
        this.typeValue = "Email";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default UserEmailPicklistMetadata;
